import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class ReceiptService {
  authToken: any;
  user: any;
  baseURI: any;

  constructor(private http: HttpClient,
    private auth: AuthService
  ) {
    this.baseURI = this.auth.baseURL;
  }

  getDepositApp() {
    let headers: HttpHeaders = new HttpHeaders();
    this.loadToken();
    headers = headers.append('Authorization', this.authToken);
    headers = headers.append('Content-Type', 'application/json');
    return this.http.get(this.baseURI + 'dapp/getDepositApp', { headers: headers });
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }
}